import React from "react";
import './style.scss'

const Footer = () =>{
return(
    <footer className="footer-section">
  </footer>
)
}

export default Footer;